<template>
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.203 24.474H7.855a4.034 4.034 0 0 1-4.029-4.029V8.677a4.034 4.034 0 0 1 4.03-4.029h1.768V6.23H7.855a2.449 2.449 0 0 0-2.447 2.447v11.768a2.449 2.449 0 0 0 2.447 2.447h11.348a2.449 2.449 0 0 0 2.447-2.447V8.677a2.449 2.449 0 0 0-2.447-2.447H17.43V4.648h1.774a4.034 4.034 0 0 1 4.03 4.03v11.767a4.034 4.034 0 0 1-4.03 4.029Z"
      :fill="disabled ? disabledColor : color"
    />
    <path
      d="M15.651 8.124h-4.245A2.36 2.36 0 0 1 9.05 5.767v-.828a2.36 2.36 0 0 1 2.357-2.357h4.245a2.36 2.36 0 0 1 2.357 2.357v.828a2.36 2.36 0 0 1-2.357 2.357Zm-4.245-3.958a.776.776 0 0 0-.775.775v.828c0 .427.348.776.775.776h4.245a.776.776 0 0 0 .775-.776v-.828a.776.776 0 0 0-.775-.775h-4.245ZM13.48 12.58H8.44a.79.79 0 1 1 0-1.582h5.043a.79.79 0 1 1-.002 1.582Zm1.71 3.348H8.44a.79.79 0 1 1 0-1.582h6.752a.79.79 0 1 1-.002 1.582Zm1.687 3.375H8.439a.79.79 0 1 1 0-1.582h8.44a.79.79 0 1 1-.002 1.582Z"
      :fill="disabled ? disabledColor : color"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ReportIcon extends Vue {
  @Prop() disabled: boolean;
  @Prop({ type: String, default: '#FFFFFF' }) color: boolean;
  @Prop({ type: String, default: '#9FAAD2' }) disabledColor: boolean;
}
</script>
